// test930
(930 && 0);
